import { performRequest } from './api-handler';
import { URLS } from '../utility/urls'

export default () => {
    const {GET_AGENT_TYPE } = URLS;
    return {
        getAgentType: (body = {}, method = 'get') =>
            performRequest(method ? method : 'get', GET_AGENT_TYPE, body),
    }
}